<div class="iu-dialog">

  <!-- Header -->
  <div class="iu-header">
    <div class="iu-title-wrap">
      <div class="iu-title-icon">
        <mat-icon>map</mat-icon>
      </div>
      <div>
        <h2 class="iu-title">{{ editing ? 'Edit floor plan' : 'Add floor plan' }}</h2>
        <span class="iu-subtitle">Upload a photo, scan, or drawing · downscaled automatically</span>
      </div>
    </div>
    <button type="button" class="iu-close" mat-dialog-close [disabled]="formSubmitted" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="floorPlanUpload" class="iu-body" (ngSubmit)="submit()">
    <input #file type="file" id="floorPlanFile" accept="image/*" (change)="pick(file.files)">

    <label class="fp-field">
      <span class="fp-field__label">Name</span>
      <input class="fp-field__input" type="text" [(ngModel)]="name" name="name"
             placeholder="e.g. Building A – Flower wing" [disabled]="formSubmitted" autocomplete="off">
    </label>

    <div class="fp-mode" role="group" aria-label="Floor plan source">
      <button type="button" class="iu-textbtn" [class.is-active]="mode === 'upload'" (click)="mode = 'upload'">
        <mat-icon>upload</mat-icon> Upload image
      </button>
      @if (!editing || !existing?.fullPath) {
        <button type="button" class="iu-textbtn" [class.is-active]="mode === 'blank'" (click)="mode = 'blank'">
          <mat-icon>grid_on</mat-icon> Start blank
        </button>
      }
    </div>

    @if (mode === 'blank') {
      <div class="row">
        <label class="fp-field col-6">
          <span class="fp-field__label">Canvas width</span>
          <input class="fp-field__input" type="number" min="200" max="5000" [(ngModel)]="canvasWidth" name="canvasWidth">
        </label>
        <label class="fp-field col-6">
          <span class="fp-field__label">Canvas height</span>
          <input class="fp-field__input" type="number" min="200" max="5000" [(ngModel)]="canvasHeight" name="canvasHeight">
        </label>
      </div>
      <mat-checkbox [(ngModel)]="showGrid" name="showGrid">Show grid</mat-checkbox>
    } @else if (processing) {
      <div class="fp-processing">
        <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
        <span>Optimizing image…</span>
      </div>
    } @else if (!imgURL) {
      <button type="button" class="iu-dropzone" [class.is-dragging]="dragging"
              (click)="browse()"
              (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <div class="iu-dropzone__icon">
          <mat-icon>cloud_upload</mat-icon>
        </div>
        <p class="iu-dropzone__lead"><span class="iu-link">Browse</span> or drag a floor plan here</p>
        <p class="iu-dropzone__hint">PNG or JPG · large images are resized for you</p>
      </button>
      @if (editing && existing?.fullPath) {
        <p class="fp-keep-note"><mat-icon>info</mat-icon> Leave empty to keep the current image.</p>
      }
    } @else {
      <div class="iu-preview">
        <div class="iu-preview__thumb iu-preview__thumb--wide">
          <img [src]="imgURL" alt="Floor plan preview">
        </div>
        <div class="iu-preview__meta">
          <span class="iu-preview__name" [title]="fileName">{{ fileName }}</span>
          <span class="iu-preview__size">
            <mat-icon>check_circle</mat-icon>
            {{ processedWidth }}×{{ processedHeight }} · {{ processedSizeLabel }}
          </span>
          <div class="iu-preview__actions">
            <button type="button" class="iu-textbtn" (click)="browse()" [disabled]="formSubmitted">
              <mat-icon>sync</mat-icon> Replace
            </button>
            <button type="button" class="iu-textbtn iu-textbtn--danger" (click)="clearSelection()" [disabled]="formSubmitted">
              <mat-icon>delete_outline</mat-icon> Remove
            </button>
          </div>
        </div>
      </div>
    }

    @if (mode === 'upload') {
      <label class="fp-field" style="margin-top: 14px;">
        <span class="fp-field__label">Background sizing</span>
        <select class="fp-field__input" [(ngModel)]="backgroundFit" name="backgroundFit">
          <option value="fit">Fit entire image</option>
          <option value="fill">Fill canvas and crop edges</option>
        </select>
      </label>
    }

    @if (message) {
      <p class="iu-message"><mat-icon>error_outline</mat-icon> {{ message }}</p>
    }
  </form>

  <!-- Footer -->
  <div class="iu-footer">
    <button type="button" class="iu-btn iu-btn--ghost" mat-dialog-close [disabled]="formSubmitted">Cancel</button>
    <button type="submit" form="floorPlanUpload" class="iu-btn iu-btn--primary" [disabled]="!canSubmit">
      @if (formSubmitted) {
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        <span>Saving…</span>
      } @else {
        <mat-icon>check</mat-icon>
        <span>{{ editing ? 'Save' : 'Add plan' }}</span>
      }
    </button>
  </div>

</div>
